import { Box, Chip, Divider, Paper, Typography, useMediaQuery } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { History, NewReleases } from "@material-ui/icons"
import React from "react"
import { useHistoricoVersoesContext } from "../context/useHistoricoVersoesContext"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "800px",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
        },
    },
    header: {
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(3),
        },
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.25rem",
        },
    },
    versaoAtualChip: {
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        fontWeight: 600,
        marginLeft: theme.spacing(1.5),
        [theme.breakpoints.down("sm")]: {
            marginLeft: 0,
            marginTop: theme.spacing(1),
        },
    },
    configCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            borderRadius: 15,
            marginBottom: theme.spacing(2),
        },
    },
    configCardAtual: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(var(--cor-botao-salvar-rgb), 0.2)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        border: "2px solid #4caf50",
        [theme.breakpoints.down("sm")]: {
            borderRadius: 15,
            marginBottom: theme.spacing(2),
        },
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    cardHeaderAtual: {
        backgroundColor: "#f0faf0",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #c8e6c9",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    cardHeaderLeft: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        flexWrap: "wrap",
    },
    cardHeaderTitle: {
        fontWeight: 700,
        color: "#2c3e50",
        fontSize: "1.1rem",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
        },
    },
    dataText: {
        color: "#7f8c8d",
        fontSize: "0.875rem",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.8rem",
        },
    },
    cardContent: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    alteracaoItem: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: theme.spacing(1.5),
        "&:last-child": {
            marginBottom: 0,
        },
    },
    alteracaoBullet: {
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: "var(--cor-botao-salvar)",
        marginTop: 8,
        marginRight: theme.spacing(1.5),
        flexShrink: 0,
    },
    alteracaoTexto: {
        color: "#34495e",
        fontSize: "0.925rem",
        lineHeight: 1.6,
        flex: 1,
        "& strong": {
            color: "#2c3e50",
            fontWeight: 600,
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem",
        },
    },
    iconHeader: {
        color: "#4caf50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem",
        },
    },
    versaoChip: {
        backgroundColor: "#e8f5e9",
        color: "#2e7d32",
        fontWeight: 700,
        fontSize: "0.85rem",
    },
    versaoChipAtual: {
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        fontWeight: 700,
        fontSize: "0.85rem",
    },
    erroBox: {
        padding: theme.spacing(4),
        textAlign: "center",
        color: "#7f8c8d",
    },
}))

export function ListaVersoes() {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { historico, erroCarregamento } = useHistoricoVersoesContext()

    if (erroCarregamento) {
        return (
            <div className={classes.container}>
                <div className={classes.content}>
                    <Box className={classes.erroBox}>
                        <History style={{ fontSize: 48, color: "#bdc3c7", marginBottom: 8 }} />
                        <Typography variant="h6" style={{ color: "#7f8c8d" }}>
                            {erroCarregamento}
                        </Typography>
                    </Box>
                </div>
            </div>
        )
    }

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <Box className={classes.header}>
                    <Box display="flex" alignItems={isMobile ? "flex-start" : "center"} flexDirection={isMobile ? "column" : "row"}>
                        <Box display="flex" alignItems="center">
                            <History className={classes.iconHeader} style={{ marginRight: 8, fontSize: "2rem" }} />
                            <Typography variant="h4" className={classes.titleText}>
                                Histórico de Versões
                            </Typography>
                        </Box>
                        {historico.versaoAtual && (
                            <Chip
                                label={`Versão atual: ${historico.versaoAtual}`}
                                className={classes.versaoAtualChip}
                                icon={<NewReleases style={{ color: "white" }} />}
                                size={isMobile ? "small" : "medium"}
                            />
                        )}
                    </Box>
                    <Typography variant="subtitle1" style={{ color: "#7f8c8d", marginTop: 4 }}>
                        Acompanhe as atualizações e melhorias do sistema
                    </Typography>
                </Box>

                {historico.versoes.map((versao, index) => {
                    const isAtual = versao.numero === historico.versaoAtual
                    return (
                        <Paper
                            key={versao.numero}
                            className={isAtual ? classes.configCardAtual : classes.configCard}
                        >
                            <Box className={isAtual ? classes.cardHeaderAtual : classes.cardHeader}>
                                <Box className={classes.cardHeaderLeft}>
                                    <Chip
                                        label={`v${versao.numero}`}
                                        className={isAtual ? classes.versaoChipAtual : classes.versaoChip}
                                        size="small"
                                    />
                                    <Typography className={classes.cardHeaderTitle}>
                                        {versao.data}
                                    </Typography>
                                </Box>
                                {isAtual && (
                                    <Chip
                                        label="Versão Atual"
                                        icon={<NewReleases style={{ color: "white", fontSize: "1rem" }} />}
                                        size="small"
                                        style={{
                                            backgroundColor: "var(--cor-botao-salvar)",
                                            color: "white",
                                            fontWeight: 600,
                                        }}
                                    />
                                )}
                            </Box>
                            <Box className={classes.cardContent}>
                                {versao.alteracoes.map((alteracao, i) => (
                                    <Box key={i}>
                                        <Box className={classes.alteracaoItem}>
                                            <Box className={classes.alteracaoBullet} />
                                            <Typography
                                                component="span"
                                                className={classes.alteracaoTexto}
                                                dangerouslySetInnerHTML={{ __html: alteracao }}
                                            />
                                        </Box>
                                        {i < versao.alteracoes.length - 1 && (
                                            <Divider style={{ margin: "4px 0 12px 22px" }} />
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        </Paper>
                    )
                })}
            </div>
        </div>
    )
}
